import React from "react";
import CategoryProductList from "./CategoryProductList";

const ClutchParts = () => {
  return (
    <CategoryProductList
      categoryName="Clutch"
      categorySlug="clutch"
    />
  );
};

export default ClutchParts;
